module.exports = __webpack_public_path__ + "img/avterracebox06.9e1d27c8.jpg";